<template>
  <div v-if="display" class="custom-ui-loader-wrapper" :class="spinType">
    <span class="custom-ui-loader" />
  </div>
</template>
<script lang="ts" setup>
  import type { IUILoader } from '@/types/Components'
  import { computed } from 'vue'

  const { type = 0 } = defineProps<IUILoader>()

  const display = computed(() => type !== 0)

  const spinType = computed(() => {
    switch (type) {
      case 1:
        return 'normal'
      case 2:
        return 'fixed'
      case 3:
        return 'absolute'
      default:
        return ''
    }
  })
</script>

<style lang="scss" scoped>
  .custom-ui-loader-wrapper {
    &.fixed {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      z-index: 1000;
      @include flexible($align: center, $justify: center);
    }
    &.absolute {
      @include flexible($align: center, $justify: center);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(53, 51, 51, 0.075);
      z-index: 1000;
    }
    &.normal {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 400px);
    }
    .custom-ui-loader {
      border: 4px solid #dedede;
      border-top: 4px solid $textColor;
      border-bottom: 4px solid $textColor;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
</style>
